"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_POPULAR_SEARCHES = void 0;
exports.GET_POPULAR_SEARCHES = `
  {
    popularSearches 
  }
`;
//# sourceMappingURL=popular-searches-queries.js.map